import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';

import { LoginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';
import { PrivateModule} from './private/private.module'

// const policyRouterOptions: ExtraOptions = {
//     useHash: false,
//     anchorScrolling: 'enabled',
// }{
//     useHash: false,
//     anchorScrolling: 'enabled',
// }

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
    },
    {
        path: 'home',
        loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
        canActivate: [LoginGuard]
    },
    {
        path: '',
        loadChildren: () => import('./private/private.module').then(m => m.PrivateModule),
        canActivate: [AuthGuard],
    },
    { path: '**', redirectTo: ''},
];

@NgModule({
    imports: [RouterModule.forRoot(routes,{
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled'
    })],
    exports: [RouterModule],
    providers: [AuthGuard],
})
export class AppRoutingModule {}
